import { createFileRoute } from '@tanstack/react-router'
import { CREDIT_ROUTES, toStaticData } from '../../credit-route-config'

export const Route = createFileRoute('/_auth/_modules/credit/admin/users')({
  staticData: toStaticData(CREDIT_ROUTES['/credit/admin/users']),
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
